import React from 'react'
import classNames from 'classnames'

export default function Container({bgColor,className, children}) {
    const classes = classNames('',{
        'bg-[#F5F5F5] rounded-[10px]': bgColor
    })
    // console.log(classes+className)
  return (
    <div className={classes+" "+className}>
      {children}
    </div>
  )
}
